import { ActionCreator, createAction, props, Action } from '@ngrx/store';

import { DeviceInfo } from '@capacitor/device';

export enum Types {
  INIT_DEVICE_INFO = '[Device] Init: Start',
  INIT_DEVICE_INFO_ERROR = '[Device] Init: Error',
  INIT_DEVICE_INFO_SUCCESS = '[Device] Init: Success',
}

export const InitDeviceInfo: ActionCreator<
  Types.INIT_DEVICE_INFO,
  (props: {}) => {} & Action<Types.INIT_DEVICE_INFO>
> = createAction(Types.INIT_DEVICE_INFO);

export const InitDeviceInfoError: ActionCreator<
  Types.INIT_DEVICE_INFO_ERROR,
  (props: {}) => {} & Action<Types.INIT_DEVICE_INFO_ERROR>
> = createAction(Types.INIT_DEVICE_INFO_ERROR);

export const InitDeviceInfoSuccess: ActionCreator<
  Types.INIT_DEVICE_INFO_SUCCESS,
  (props: { deviceInfo: DeviceInfo }) => {
    deviceInfo: DeviceInfo;
  } & Action<Types.INIT_DEVICE_INFO_SUCCESS>
> = createAction(
  Types.INIT_DEVICE_INFO_SUCCESS,
  props<{ deviceInfo: DeviceInfo }>()
);
